import { defineComponent } from 'vue';
import QuartlyHumanResourceComponent from '@/components/QuartlyHumanResource/QuartlyHumanResourceComponent.vue';
export default defineComponent({
    name: 'QuartlyHumanResource',
    components: { QuartlyHumanResourceComponent },
    data() {
        return {};
    }
});
